import { render, staticRenderFns } from "./AlcadaForm.vue?vue&type=template&id=70a9bf1b&lang=html&"
import script from "./AlcadaForm.vue?vue&type=script&lang=js&"
export * from "./AlcadaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/alcada/AlcadaForm.vue
// module id = 1026
// module chunks = 28